import React from 'react'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings/hexColors'
import * as iconPaths from '@mobi/component-library/Common/Icon/iconPaths'
import { useInducementService } from '@core/Utils/hooks/useInducementService'

export const SpecialIndicator: React.FC<{
  height?: string
  width?: string
  className?: string
  viewBox?: string
}> = ({ height, width, className, viewBox }) => {
  const canShowInducements = useInducementService()

  return canShowInducements ? (
    <SpecialIndicatorStyled
      width={width || '24'}
      height={height || '24'}
      viewBox={viewBox || '0 0 256 256'}
      role='presentation'
      className={className}
      style={{ width, height }}
      data-tid-special-icon=''
    >
      <path fill={hexColors.white} d={iconPaths.specialsBackground} />
      <path d={iconPaths.specials} />
    </SpecialIndicatorStyled>
  ) : null
}

// ======
// Styles
// ======

const SpecialIndicatorStyled = styled.svg({
  display: 'inline-block',
  fill: hexColors.orange,
  width: '2rem',
  height: '2rem',
  verticalAlign: 'middle',
})
